import gql from 'graphql-tag';

import type { Job } from 'src/data/job';
import type { PerformanceCenterCustomerResourceInputType } from 'src/data/performance';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import { FRAGMENT_JOB } from 'src/graphql/job';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ImportBrandTermsForWebsiteOrPdf(
    $workspaceId: ID!
    $brandVoiceId: ID!
    $input: PerformanceCenterCustomerResourceInputType!
    $glossary: Boolean!
  ) {
    importBrandTermsForWebsiteOrPdf(
      workspaceId: $workspaceId
      brandVoiceId: $brandVoiceId
      input: $input
      glossary: $glossary
    ) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

interface Variables extends GqlCallVariables {
  workspaceId: ID;
  brandVoiceId: ID;
  input: PerformanceCenterCustomerResourceInputType;
  glossary: boolean;
}

export const importBrandTermsForWebsiteOrPdf = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Job>(result.data);
};
